import React from 'react';
import styled from '../../../../../lib/styles';
import Spacer from '../../../../../components/presentational/Spacer';
import CardBlock, { CustomCard } from '../CardBlock';
import cardGridBlockStyles from './CardGridBlock_styles';
import * as logging from '../../../../../server/logging';

export interface CardGridBlockData {
  type: 'card_grid_block';
  cards: CustomCard[];
}

export interface CardGridBlockProps {
  block: CardGridBlockData;
}

const CardGridBlock = ({ block: { cards }, styles }) => {
  logging.silly({ cards: cards }, 'CardGridBlock');
  return (
    <div className={`card-grid-block ${styles.container}`}>
      <Spacer width={1160} space={['m', 'l']}>
        {cards.map((card, key) => {
          return (
            <div
              key={key}
              className={`card-grid-block-item ${styles.blockItem}`}
            >
              <a href={card.link} title={card.title}>
                <div>
                  <img
                    loading={'lazy'}
                    className={card.mobile_image ? styles.responsiveImage : ''}
                    data-cfsrc={card.image}
                    alt={card.title}
                    src={card.image}
                  />
                  {card.mobile_image ? (
                    <img
                      loading={'lazy'}
                      className={styles.mobileImage}
                      data-cfsrc={card.mobile_image}
                      alt={card.title}
                      src={card.mobile_image}
                    />
                  ) : (
                    <></>
                  )}
                </div>
                <label className={styles.label}>{card.title}</label>
              </a>
            </div>
          );
        })}
      </Spacer>
    </div>
  );
};

export default styled(cardGridBlockStyles)(CardGridBlock);
